//基础路由
export const constantRouterMap = [
    {
        path: '/', 
        redirect: '/',
        children: [
            {
                path: '/',
                meta:{
                    title:'首页'
                },
                component: () => import('@/pages/index/Index')
            }
        ]
    },
    {
        path: '/service_agreement',
        meta:{
            title:'服务协议'
        },
        component: () => import('@/pages/agreement/ServiceAgreement')
    },
    {
        path: '/privacy_agreement',
        meta:{
            title:'隐私政策'
        },
        component: () => import('@/pages/agreement/PrivacyAgreement')
    },
    {
        path: '/pay_agreement',
        meta:{
            title:'付费服务协议'
        },
        component: () => import('@/pages/agreement/PayAgreement')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
        children: [
            {
                path: '/404',
                component: () => import( '@/pages/404')
            }
        ]
    },
    
];